import { all, fork } from 'redux-saga/effects';

import { effects as shipmentEffects } from 'state/mrCollection/shipments';

export default function* mrCollectionSaga() {
  yield all([fork(shipmentEffects)]);
}
